import { http } from '@/core/api/';

const baseURL = 'api/discipline';

export default {
  getChildCountSearchInitialFilterValues(properties) {
    return http.get('api/discipline/initfilters', {
      params: {
        ...properties,
      },
    });
  },
  getDisciplineSearchData(properties) {
    return http.get('api/discipline', {
      params: {
        ...properties,
      },
    });
  },
  searchStudent(
    childCountCertificationId,
    studentSieIdOrRegistry,
    academicYearId,
    locationSchoolId
  ) {
    return http.get(
      `${baseURL}/${childCountCertificationId}/studentsearch/${studentSieIdOrRegistry}/${academicYearId}/${locationSchoolId}`
    );
  },
  addStudent(childCountCertificationId, studentSieId) {
    return http.post(`${baseURL}/addStudent`, {
      childCountCertificationId,
      studentSieId,
    });
  },
  getSchoolCustodian(locationSchoolId) {
    return http.get(`${baseURL}/schoolcustodians`, {
      params: {
        locationSchoolId,
      },
    });
  },
  assignCustodian(childCountCertificationStudentId, custodianUserId) {
    return http.put(`${baseURL}/assingcustodian`, {
      childCountCertificationStudentId,
      custodianUserId,
    });
  },
  include(childCountStudentCertificationId, academicYearId, locationSchoolId) {
    return http.post(`${baseURL}/include`, {
      childCountStudentCertificationId,
      academicYearId,
      locationSchoolId,
    });
  },
  removeManualStudent(childCountCertificationStudentId) {
    return http.delete(`${baseURL}/removestudent`, {
      params: {
        childCountCertificationStudentId,
      },
    });
  },
  async submitCertification(certificationId) {
    return await http.put(`${baseURL}/submit`, {
      certificationId: certificationId,
    });
  },
  async loadStudentCertification(
    certificationId,
    isPrivateSchool,
    searchMode,
    filters = {}
  ) {
    return await http.get(`${baseURL}/studentcertifications`, {
      params: {
        certificationId: certificationId,
        StudentFilter: filters.sie,
        CustodianUserId: filters.teacher,
        alertFilterId: filters.alertFilterId,
        searchMode,
        isPrivateSchool,
      },
    });
  },
  async deleteStudentCertification(studentCertificationId) {
    return await http.delete(
      `${baseURL}/studentcertifications/${studentCertificationId}`
    );
  },
  async loadCertification(certificationId) {
    return await http.get(`${baseURL}/certifications`, {
      params: {
        certificationId: certificationId,
      },
    });
  },
  async loadStudentExcludeReasons() {
    return await http.get(`api/code/childcountexcludereasons`);
  },
  async getSchoolCustodianAsync(locationSchoolId) {
    return await http.get(`${baseURL}/schoolcustodians`, {
      params: {
        locationSchoolId,
      },
    });
  },
  markAllToChangeStatus(properties, flagSelection) {
    return http.post(
      `${baseURL}/markalltochangestatus/${flagSelection}`,
      properties
    );
  },
  markIndividualToChangeStatus(certificationId, flagSelection) {
    return http.post(
      `${baseURL}/changeflagselectionindividual/${certificationId}/${flagSelection}`
    );
  },
  existSelectionToChangeStatus(properties) {
    return http.post(`${baseURL}/existselectiontochangestatus`, properties);
  },
  approveMultiple(properties) {
    return http.post(`${baseURL}/approvemultiple/`, properties);
  },
  getProgress(acedemicYearId) {
    return http.get(`${baseURL}/progress/${acedemicYearId}`);
  },
  changePreviousStatus(certificationId) {
    return http.post(`${baseURL}/changepreviousstatus/${certificationId}`);
  },
  getHistory(id) {
    return http.get(`${baseURL}/history/${id}`);
  },
};
